import PlatformActions from './PlatformActions'

export default class HACKSAWEGAMEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'HACKSAW',
      gameType: 'EGAME',
      gameCode: 'HACKSAW-EGAME-001',
    }

    this.gameName = 'Mines'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `HS011-50000${roundId}_HS011-50000${wagerId}`, // HS011-5000015925908
      roundId: `HS011-50000${roundId}`, // HS011-5000015925908
      betType: null,
      currency,
      betTime, // 2025-05-12T17:03:06.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        betType: '1',
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      isEndRound = true,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `HS011-50000${roundId}_HS011-50000${wagerId}`, // HS011-5000031256538
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2025-05-12T17:03:07.287+08:00
      roundId: `HS011-50000${roundId}`, // HS011-5000015925908
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betType: '1',
        isEndRound: `${isEndRound}`,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `HS011-50000${roundId}_HS011-50000${wagerId}`,
      roundId: `HS011-50000${roundId}`,
      gameInfo: {
        betType: '1',
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
